<template>
  <div v-if="showImage" class="popup-backdrop" @click="closePopup">
    <div class="popup-wrapper">
      <!-- Gambar -->
      <img :src="imageUrl" alt="Popup" class="popup-image"  @click="goTo"/>

      <!-- Tombol close -->
      <span class="close-button" @click="closePopup">&times;</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "PopupCampaign",
    data() {
        return {
			showImage: false,
			imageUrl: "/img/promo_merdeka.png"
		}
    },
    computed: {
		...mapGetters(["isLoading", "getKlinikId", "getUser", "getRolesName"]),
    },
    methods: {
        isPic() {
          return /pic/.test(this.getRolesName);
        },
        openPopUp() {
          const showCampaign = JSON.parse(localStorage.getItem('show_campaign'))
          
          if (this.getKlinikId && showCampaign.is_open == false && showCampaign.counter == 0) {
            this.showImage = true;
            localStorage.setItem('show_campaign', JSON.stringify({
              is_open: true,
              counter: 1
            }));
          }
        },
        closePopup() {
          this.showImage = false;
          localStorage.setItem('show_campaign', JSON.stringify({
            is_open: true,
            counter: 1
          }));
        },
        goTo(event) {
          if (this.isPic()) {
            this.$router.push('/klinik/subskripsi/paket/berlangganan');
          } else {
            // Mencegah popup tertutup karena bubbling
            event.stopPropagation();
          }
        }
    },
    mounted() {
        if (this.getKlinikId && this.getUser) {
			const showCampaign = JSON.parse(localStorage.getItem('show_campaign'));

			localStorage.setItem('show_campaign', JSON.stringify({
				is_open: false,
				counter: showCampaign ? showCampaign.counter : 0 
			}));
			this.openPopUp()
		}
    }
}

</script>

<style scoped>
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Wrapper yang hanya sebesar gambar */
.popup-wrapper {
  position: relative;
  display: inline-block;
}

/* Gambar */
.popup-image {
  max-width: 65vw;
  max-height: 65vh;
  display: block;
  border-radius: 8px;
  /* box-shadow: 0 0 10px #000; */
  /* border: 5px solid #fff; Bingkai putih 5px */
  padding: 5px; /* Memberikan jarak antara gambar dan bingkai */
  /* background: #ffffff; */
  cursor: pointer;
}

/* Tombol close di pojok kanan atas gambar */
.close-button {
  position: absolute;
  top: -15px;
  right: -15px;
  font-size: 1.5rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  padding: 4px 13px;
  cursor: pointer;
  z-index: 10000;
}

/* Responsif untuk tampilan mobile */
@media (max-width: 768px) {
  .popup-image {
    max-width: 90vw; /* Ukuran untuk mobile */
    max-height: 90vh;
  }
}
</style>
